import script from "./RadioButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./RadioButtons.vue?vue&type=script&setup=true&lang=js"

import "./RadioButtons.vue?vue&type=style&index=0&id=13bcd31c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13bcd31c"]])

export default __exports__